// extracted by mini-css-extract-plugin
export default {"input-field":"InputField_input-field__JXzdR","header-text":"InputField_header-text__HDS46"};